module.exports = __webpack_public_path__ + "static/img/environment_04_h5.96f9fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_04_h5.png
// module id = 9HxI
// module chunks = 34